export const PERIOD_PRESET_TYPE_LABELS = {
  absolute: "Фиксированный",
  relative: "Относительный",
  tracking: "С даты",
} as const;

export const PERIOD_UNIT_LABELS = {
  day: "дни",
  week: "недели",
  month: "месяцы",
} as const;
